/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const Instagram24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Instagram 24">
      <g className="SVG">
        <path fill="#0E0E0E" d="M19 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
        <path
          fill="#0E0E0E"
          fillRule="evenodd"
          d="M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
          clipRule="evenodd"
        />
        <path
          fill="#0E0E0E"
          fillRule="evenodd"
          d="M2 11.6c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C6.56 2 8.24 2 11.6 2h.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C22 6.56 22 8.24 22 11.6v.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C17.44 22 15.76 22 12.4 22h-.8c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C2 17.44 2 15.76 2 12.4v-.8ZM11.6 4h.8c1.713 0 2.878.002 3.778.075.877.072 1.325.202 1.638.361a4 4 0 0 1 1.748 1.748c.16.313.29.761.36 1.638.074.9.076 2.065.076 3.778v.8c0 1.713-.002 2.878-.075 3.778-.072.877-.202 1.325-.361 1.638a4 4 0 0 1-1.748 1.748c-.313.16-.761.29-1.638.36-.9.074-2.065.076-3.778.076h-.8c-1.713 0-2.878-.002-3.778-.075-.877-.072-1.325-.202-1.638-.361a4 4 0 0 1-1.748-1.748c-.16-.313-.29-.761-.36-1.638C4.001 15.278 4 14.113 4 12.4v-.8c0-1.713.002-2.878.075-3.778.072-.877.202-1.325.361-1.638a4 4 0 0 1 1.748-1.748c.313-.16.761-.29 1.638-.36C8.722 4.001 9.887 4 11.6 4Z"
          clipRule="evenodd"
        />
      </g>
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Instagram24,
  md: Instagram24,
  lg: Instagram24,
  xl: Instagram24,
  xxl: Instagram24,
  xxxl: Instagram24,
};

export const InstagramIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'instagram-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
